import React from 'react'
import assets from '../assets'
import './index.css'
import { motion } from 'framer-motion'

const Section1 = ({variants}) => {
  return (
    <div className='minSection'>
        <div className="container-lg flex flexCol alignCenter extraMbottom relative">
           {assets.arrowDown}
           <img className='lightTitle' src={assets.light.lightTitles} alt="Light" />
            <motion.p 
            variants={variants}
            initial={'initial'}
            whileInView={'inView'}
            transition={{ duration: 0.7, delay: .3 }}
            viewport={{ once: true }}
            className='textCenter parDes'
            >
                ECON layer one enables <strong>transparent collateralized</strong> smart contracts on different assets real time values, allowing contract <strong>swap to original assets</strong>, automated cashflows and <strong>multi-chain Interoperability.</strong>
            </motion.p>
        </div>
    </div>
  )
}

export default Section1